import { atom } from "jotai";

export const datosPerfilAtom = atom(undefined);